import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Products.css";
import ataImage from "../assets/images/ata.png";
import ziynetImage from "../assets/images/ziynet.png";
import log3Image from "../assets/images/log3.png";
import { FaInfoCircle } from "react-icons/fa"; // React Icons eklentisiyle ikonlar

const Products: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="products-container">
      <div className="breadcrumb">ANASAYFA / ÜRÜNLERİMİZ</div>
      <div className="products-logo-container">
        <img src={log3Image} alt="Logo" className="products-logo" />
      </div>
      <div className="product-cards">
        <div className="product-card">
          <img src={ataImage} alt="Ata Altın" />
          <h2>Ata Altın Grubu</h2>
          <p>
            Ata altın grubundaki ürünlerimiz hakkında detaylı bilgi için aşağıdaki butona tıklayın.
          </p>
          <button onClick={() => navigate("/altin")}>
            <FaInfoCircle className="button-icon" /> Detay
          </button>
        </div>

        <div className="product-card">
          <img src={ziynetImage} alt="Ziynet Altın" />
          <h2>Ziynet Altın Grubu</h2>
          <p>
            Ziynet altın grubundaki ürünlerimiz hakkında detaylı bilgi için aşağıdaki butona tıklayın.
          </p>
          <button onClick={() => navigate("/altin")}>
            <FaInfoCircle className="button-icon" /> Detay
          </button>
        </div>
      </div>
    </div>
  );
};

export default Products;
